import { useReconciliationMerchants } from 'pages/Finance/Reconciliation/hooks/useReconciliationMerchants';
import { ReconciliationFormValues } from 'pages/Finance/Reconciliation/utils/mapReconciliationFormToFormData';
import { useFormContext } from 'react-hook-form';
import { SelectInput } from 'shared/react-admin/Inputs';

type Props = {
  readOnly?: boolean;
};

export const ReconciliationMerchantInput: React.FC<Props> = ({ readOnly }) => {
  const { setValue } = useFormContext<ReconciliationFormValues>();
  const { data: merchants, isLoading } = useReconciliationMerchants();

  return (
    <SelectInput
      choices={merchants ?? []}
      fullWidth
      isPending={isLoading}
      isRequired
      label="Мерчант"
      onChange={() => setValue('provider', null)}
      readOnly={readOnly}
      source="merchant"
      variant="outlined"
    />
  );
};
